module.exports = __webpack_public_path__ + "images/emoji/snowflake.5c96bfe53eddc908a8ca.png";